import styles from './RawButton.module.scss';
import cx from 'classnames';

import React from 'react';

interface RawButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
  resetStyles?: boolean;
}

export const RawButton: React.FC<RawButtonProps> = ({
  children,
  onClick,
  title,
  disabled = false,
  className = '',
  resetStyles = true,
}) => {
  return (
    <button
      className={cx({ [styles.rawButton]: resetStyles }, className)}
      onClick={onClick}
      disabled={disabled}
      title={title}
      type="button"
    >
      {children}
    </button>
  );
};
